import dayjs from "dayjs";
import { ServerGateway } from "./ServerGateway";
import { GcSessionInfo } from "@glamcorner/gc-types/generated/types";
import { TierCode, TiersAccessible } from "@glamcorner/gc-types/lib/subscription";
import { ALL_SUBSCRIPTION_TIERS } from "../constants";

export class SubscriptionService {
  private readonly gateway: ServerGateway;

  private NEXT_BOX_DATE_IN_DAYS = 32;

  constructor(gateway: ServerGateway) {
    this.gateway = gateway;
  }

  public async getNextBillingPeriod(): Promise<{ startDate: string; endDate: string }> {
    const customerProfile = await this.gateway.getCustomerProfile();

    const builtBoxThisBillingPeriod = await this.gateway.getBuiltBoxThisBillingPeriod();

    const startDate = (builtBoxThisBillingPeriod && customerProfile?.customerSubscription?.nextBillingDate) || "";

    const endDate = startDate
      ? dayjs(startDate, "YYYY-MM-DD").add(this.NEXT_BOX_DATE_IN_DAYS, "day").format("YYYY-MM-DD")
      : "";

    return { startDate, endDate };
  }

  public async getCustomersTiers(allFallback = false): Promise<string[]> {
    let tiers: string[] | undefined;

    const profile = await this.gateway.getCustomerProfile();
    if (profile) {
      tiers = profile.customerSubscription?.tiersAccessible;
    }

    if (!tiers) {
      tiers = allFallback ? ALL_SUBSCRIPTION_TIERS : [];
    }

    return tiers;
  }

  public static isSubscriptionCustomer(gcSessionInfo: GcSessionInfo | null) {
    if (gcSessionInfo?.loggedIn) {
      return gcSessionInfo?.customerInfo?.customerGroup?.startsWith("subscription");
    }

    return false;
  }

  public static sortTiers(tiers: TiersAccessible) {
    const order = ["lite", "premium", "ultimate", "legacy"];

    return tiers.sort((a, b) => order.indexOf(a) - order.indexOf(b));
  }

  public static minimumTier(tiers: TiersAccessible): TierCode {
    return this.sortTiers(tiers)[0];
  }
}
